import {
  HttpEvent, HttpHandler, HttpInterceptor,
  HttpRequest, HttpErrorResponse, HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';
/**
It is also important to tell the http-calls which header to use. “Application/Json” in this case.
We are doing this via an interceptor and the new HttpClientModule.
**/
@Injectable()
export class CustomInterceptor implements HttpInterceptor {

  constructor(
    public router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.headers.has('Content-Type')) {
      req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
      req = req.clone({ headers: req.headers.set('Authorization', 'bearer ' + localStorage.getItem('Token')) });
      req = req.clone({ headers: req.headers.set('Access-Control-Allow-Origin', '*') });
      req = req.clone({ headers: req.headers.set('Access-Control-Allow-Methods', '*') });
      req = req.clone({ headers: req.headers.set('Access-Control-Allow-Headers', '*') });
      req = req.clone({ headers: req.headers.set('Allow-Origin-With-Credentials', '*') });
      req = req.clone({ withCredentials: true });
    }

    req = req.clone({ headers: req.headers.set('Accept', 'application/json') });
    if (req.url.indexOf('WidgetRfq/') !== -1 && environment.widgetApiKey) {
      req = req.clone({ headers: req.headers.set('X-Widget-Api-Key', environment.widgetApiKey) });
    }
    return next.handle(req).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // const elapsed = Date.now() - started;
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        switch ((<HttpErrorResponse>err).status) {
          case 400:
            break;
          case 401:
            console.log('-------401 error-----');
            if (req.url.indexOf('WidgetRfq/') === -1) {
              this.router.navigateByUrl('/auth/login/simple');
            }
            break;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/CustomInterceptor.ts